import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import Zago from "../../images/logo-zago.png";
import "../../css/App.css";

export default function LoginScreen({ loading = false }) {
  const { loginWithRedirect } = useAuth0();

  if (loading) {
    return (
      <div className="login">
        <div className="login-hero">
          <img className="login-brand" src={Zago} alt="Zago" />
          <div className="login-loading" aria-label="Chargement" />
        </div>
      </div>
    );
  }

  return (
    <div className="login">
      <div className="login-hero">
        <img className="login-brand" src={Zago} alt="Zago — A World of Design" />
        <h1 className="login-title">Instock</h1>
        <p className="login-tagline">
          Consultez la disponibilité de vos produits en temps réel.
        </p>
        <button
          type="button"
          className="auth0-button"
          onClick={() => loginWithRedirect()}
        >
          <img src="/auth0_logo.png" alt="" />
          <span>Connexion</span>
        </button>
        <p className="login-status">Accès sécurisé Groupe Zago</p>
      </div>
    </div>
  );
}
